import { Accordion, AccordionDetails, AccordionSummary } from '@mui/material';
import ArrowLeftIcon from '@mui/icons-material/ArrowLeft';
import { ReactElement } from 'react';

type ConnectionSectionProps = {
  title: ReactElement;
  detail: ReactElement;
};

export const ConnectionSection = ({
  title,
  detail,
}: ConnectionSectionProps) => {
  return (
    <Accordion
      elevation={0}
      defaultExpanded
      disableGutters
      sx={{
        backgroundColor: 'inherit',
        '&:before': {
          height: 0,
        },
      }}
      TransitionProps={{
        timeout: 500,
      }}
    >
      <AccordionSummary
        expandIcon={
          <ArrowLeftIcon
            sx={{ width: 30, height: 30, color: 'text.primary' }}
          />
        }
        sx={{
          my: 0,
          '& .MuiAccordionSummary-expandIconWrapper': {
            width: 30,
            height: 30,
          },
          '& .MuiAccordionSummary-expandIconWrapper.Mui-expanded': {
            transform: 'rotate(-90deg)',
          },
        }}
      >
        {title}
      </AccordionSummary>
      <AccordionDetails>{detail}</AccordionDetails>
    </Accordion>
  );
};
